// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2wtEV","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2rO4-"};